var WDN = WDN || {};

if (typeof WDN.TilbudToggle === "undefined") {
  WDN.TilbudToggle = (function () {
    class TilbudToggle extends HTMLElement {
      constructor() {
        super();
      }

      onClick() {
        this.setState(!this.isActive);

        // Update layout
        var firstFilter = document.querySelector("wdn-filter");

        if (firstFilter) {
          firstFilter.updateLayout();
        }
      }

      setState(isActive) {
        var searchParams = new URLSearchParams(window.location.search);

        // Update state
        this.isActive = isActive;

        // Determine whether to set/delete url params
        if (this.isActive) {
          searchParams.set("filter.p.m.filter.tilbud", "yes");
        } else {
          searchParams.delete("filter.p.m.filter.tilbud");
        }

        // Update checkbox state
        this.updateCheckbox();

        // Push state
        window.history.pushState("", "", "?" + searchParams.toString());

        // Fire custom event
        document.dispatchEvent(
          new CustomEvent("extraFilter:updated", {
            detail: {
              id: "tilbud",
              isActive: this.isActive,
            },
          })
        );
      }

      updateCheckbox() {
        if (this.isActive) {
          this.setAttribute("data-checked", "");
          return;
        }

        this.removeAttribute("data-checked");
      }

      setInitialState() {
        var searchParams = new URLSearchParams(window.location.search);
        this.isActive = searchParams.get("filter.p.m.filter.tilbud") === "yes";
        this.updateCheckbox();
      }

      // Event fired when one of the checkboxes changed
      onGlobalChange(e) {
        // If updated state is the same as the current state - skip
        if (this.isActive === e.detail.isActive) return;

        this.isActive = e.detail.isActive;
        this.updateCheckbox();
      }

      listenForEvents() {
        // Bind functions
        this.onClickBound = this.onClick.bind(this);
        this.onGlobalChangeBound = this.onGlobalChange.bind(this);

        // Self click
        this.addEventListener("click", this.onClickBound);

        // Listen for tilbud-toggle update
        document.addEventListener("extraFilter:updated", this.onGlobalChangeBound);

        // Listen for fetch success
        document.addEventListener("filters:fetch:success", this.setInitialState.bind(this));
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onClickBound);
        document.removeEventListener("extraFilter:updated", this.onGlobalChangeBound);
      }

      connectedCallback() {
        this.setInitialState();
        this.listenForEvents();
      }
    }

    customElements.define("tilbud-toggle", TilbudToggle);
    return {};
  })();
}
